import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import "./styles/customize-material.scss";
import "./styles/globals.scss";
// Import axios configuration to set up interceptors
import './config/axiosConfig';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
